// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"CompanyAvatar_avatarContainer__rZCBK"};